
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _, { forEach } from "lodash";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import request from "@/lib/request/request";
import ExamList from "@/lib/model/exam/exam";
import ExamListForm from "@/lib/form/exam/ExamListForm";
import { StructDimensionGroupConfig } from "@/lib/model/exambuilder/configGroup";
import {
  getRuleUseConfig,
  ruleUseListConfig,
  tagSentimentList
} from "./config";
import { isShunfengCompany } from "@/utils/sf";
import Auth from "@/lib/common/auth";
import { UseRule } from "@/lib/model/workerbuilder/exam-v3";

interface TagForm {
  mergeType: "AND" | "OR";
}

interface RuleForm {
  ruleId?: number;
  attribute: string;
  relationship: string;
  propName?: string[];
  value?: string | string[];
  value1?: string;
  value2?: string;
  key?: number;
  dataTypeList?: any;
  dataType?: string;
  valueOptions?: any;
  hasOr?: boolean;
  inputType?: string;
  tagAttrList?: any;
  valueInt?: number;
  valueRange?: [number, number];
  valueRangeFloat?: [number, number];
  valueStrings?: string[];
  questionId?: number;
  paramName?: string;
  dimensionName?: string;
  checkpointName?: string;
  optionName?: string; // 普工版
  dimensionGroupName?: string;
}

interface TagApplication {
  configId?: number;
  type: string;
  sort: number | "";
  tagStatusList?: any;
  evalPropName?: string;
  subExamId?: string;
  auditStatus?: string;
  auditDesc?: string;
  auditMember?: string;
  aiRecommendStatus?: number;
  tagName?: string;
  message?: string;
  messageType?: number;
  dimensionGroupName?: string;
  dimensionName?: string;
  dimensionLevel?: number;
  dimensionLevelDesc?: string;
  tagSentiment?: number; // 命中原因 打标签-标签情感倾向 0:无 1:正向 2:中性 3:负向
  tagDesc?: string; // 对 内容 输入框的描述，用于生成顺丰【住宅区】等回传标签的分析依据
}

interface Rule {
  tagForm: TagForm;
  ruleList: RuleForm[];
  tagApplication: TagApplication;
  key?: number;
  hasOr?: boolean;
  assign?: any;
  applicationRuleId?: number;
}

const defaultSetRule: Rule = {
  tagForm: {
    mergeType: "AND"
  },
  ruleList: [
    {
      attribute: "",
      relationship: "",
      value: "",
      key: 1,
      dataType: "testResult",
      propName: [],
      dataTypeList: [],
      tagAttrList: []
    }
  ],
  tagApplication: {
    type: "",
    tagSentiment: 0,
    tagDesc: "",
    auditStatus: "",
    sort: "",
    tagStatusList: [],
    subExamId: ""
  },
  key: -1
};

@Component({})
export default class TagEdit extends Vue {
  @Prop({}) exam!: ExamV2Custom;
  @Prop({}) visible!: boolean;
  @Prop({}) form!: any;
  @Prop({}) subForm!: any;
  @Prop({}) isEditExam!: boolean;
  @Prop({}) modifyOrAddIndex!: number; // 修改对应条目或者新增的索引
  title = "规则集";

  fixedList = [
    "命中",
    "未命中",
    "部分命中",
    "部分未命中",
    "全部命中",
    "全部未命中"
  ];

  unValueTypeList = ["submitType", "psyc5", "auditStatus"]; // 新增的标签属性类型

  subList: any = [];
  emptyList = ["为空", "不为空"];

  ruleSetList: Rule[] = JSON.parse(JSON.stringify([defaultSetRule]));

  // 实际在页面展示的 ruleSetList，兼容编辑全部和编辑一条两种场景
  displayRuleSetList: Rule[] = JSON.parse(JSON.stringify([defaultSetRule]));

  hasOr = false;

  ruleKey = -1;
  key = 1;

  useForm = {
    type: "",
    auditStatus: "",
    sort: ""
  };

  evalPropName = "";

  attributeList: any = [];
  dataTypeList: any = [];
  tagAttrList: any = [];

  ruleUseList = ruleUseListConfig;

  tagSentimentList = tagSentimentList;

  tagDescSuggestions: any = [
    {
      value: "收派员适合在工业区开展工作",
      label: "工业区"
    },
    {
      value: "收派员适合在住宅区开展工作",
      label: "住宅区"
    },
    {
      value: "收派员擅长做业务开拓",
      label: "业务开发能力"
    },
    {
      value: "收派员具备未来成为管理者的潜力",
      label: "管理潜力"
    }
  ];

  // 内容描述的建议词匹配(用于顺丰 工业区、住宅区、业务开发能力、管理潜力 四个标签，回传数据时，让大模型生成回传【分析依据】的)
  queryTagDescSearch(queryString: string, cb: Function) {
    const tagDescSuggestions = this.tagDescSuggestions;
    const createFilter = (queryString: string) => {
      return (tagDescSuggestion: any) => {
        return (
          tagDescSuggestion.value
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    };
    const results = queryString
      ? tagDescSuggestions.filter(createFilter(queryString))
      : tagDescSuggestions;
    cb(results);
  }

  isShunfeng() {
    return isShunfengCompany(Auth.companyId);
  }

  applicationRuleList: any = [];

  tagStatusList: any = null;

  @Watch("visible", { immediate: true })
  async getForm(nval: any) {
    if (nval) {
      this.applicationRuleList = JSON.parse(
        JSON.stringify(this.exam.applicationRuleList)
      );
      if (!this.isEditExam) {
        await this.getCompanyDimGroup();
      }
      this.getList();
      // getSubList 没有啥用吧，先注释掉
      // this.getSubList();
      // this.myForm = JSON.parse(JSON.stringify(this.form))
      // this.useForm = JSON.parse(JSON.stringify(this.subForm))
    }
  }

  created() {
    //
    // this.getList()
  }

  // 调整排序的最大值
  get sortNumberMax() {
    return this.ruleSetList.length || 1;
  }

  // 调整规则的顺序
  handleRuleIndexChange(newIndex: number, originalIndex: number) {
    if (newIndex !== originalIndex) {
      this.adjustRulePosition(originalIndex, newIndex);
    }
  }

  adjustRulePosition(fromIndex: number, toIndex: number) {
    // 确保索引在有效范围内
    if (
      fromIndex < 0 ||
      fromIndex >= this.ruleSetList.length ||
      toIndex < 0 ||
      toIndex >= this.ruleSetList.length
    ) {
      return;
    }

    // 移除原位置的规则
    const [rule] = this.ruleSetList.splice(fromIndex, 1);

    // 将规则插入到新位置
    this.ruleSetList.splice(toIndex, 0, rule);
  }

  adjustRule(index: number, type: "up" | "down") {
    if (type === "up") {
      this.adjustRulePosition(index, index - 1);
    } else {
      this.adjustRulePosition(index, index + 1);
    }
  }

  dimensionGroupConfigList: StructDimensionGroupConfig[] = [];
  getCompanyDimGroup() {
    // 获取公司级维度组 新建时用
    request.post("/aiExam/company/dimensionGroup").then(res => {
      if (res.data.code === 0) {
        this.dimensionGroupConfigList = res.data.data.dimensionGroupConfigList;
      }
    });
  }

  // 新增的话，modifyOrAddIndex 等于 this.exam.applicationRuleList 的长度
  // 修改的话，modifyOrAddIndex > -1 && modifyOrAddIndex < this.exam.applicationRuleList 的长度
  get onlyModifyOneRule() {
    return (
      (this.modifyOrAddIndex > -1 &&
        this.modifyOrAddIndex <= this.exam.applicationRuleList?.length) ||
      0
    );
  }

  // 如果是修改指定行，那么只加载指定行
  handleOnlyModifyOneRule() {
    let tempList: Rule[] = [];
    // 添加逻辑：如果指定修改某一行的话，则只修改指定行
    if (this.onlyModifyOneRule) {
      if (this.modifyOrAddIndex < this.ruleSetList.length) {
        tempList = [this.ruleSetList[this.modifyOrAddIndex]];
      } else {
        // 新增一行
        tempList = JSON.parse(JSON.stringify([defaultSetRule]));
      }
    } else {
      // 修改全部
      tempList = this.ruleSetList;
    }
    this.displayRuleSetList = tempList;
  }

  // 校验展示的数据（有时候展示多条，有时候仅仅展示一条），如果校验不通过，返回 false，否则返回 true
  validateDisplayRuleSetList() {
    let checkResult = true;
    forEach(this.displayRuleSetList, (item: Rule, index: number) => {
      // 如果 tagSeintiment 有值，那么 tagDesc 必输
      if (
        this.isShunfeng() &&
        item.tagApplication.type === "打标签" &&
        item.tagApplication.tagSentiment &&
        item.tagApplication.tagSentiment !== 0 &&
        !item.tagApplication.tagDesc
      ) {
        this.$message.error(`规则集${index + 1}的内容描述不能为空`);
        checkResult = false;
        return;
      }
    });
    return checkResult;
  }

  // 修改了指定行之后，在点击确定按钮（保存）的时候，需要将修改后的规则重新赋值给
  // applicationRuleList 数组中
  handleBeforeOk() {
    const validator = this.validateDisplayRuleSetList();

    if (this.onlyModifyOneRule) {
      this.ruleSetList.splice(
        this.modifyOrAddIndex,
        1,
        this.displayRuleSetList[0]
      );
    } else {
      this.ruleSetList = this.displayRuleSetList;
    }

    return validator;
  }

  // 解析列表
  anaylisList() {
    let applicationRuleList =
      JSON.parse(JSON.stringify(this.exam.applicationRuleList)) || [];
    const ruleSetList: Rule[] = [];
    const ruleConstKey = [
      "key",
      "attribute",
      "relationship",
      "valueRange",
      "valueRangeFloat",
      "value1",
      "value2",
      "value",
      "valueInt",
      "valueStrings",
      "ruleId",
      "mergeType",
      "detail",
      "subList",
      "propName"
    ];
    applicationRuleList.forEach((el: any) => {
      if (el.type !== "级联面试分配") {
        this.ruleKey--;
        const tagForm: TagForm = {
          mergeType: el.matchRuleRoot?.mergeType
        };
        const tagApplication: TagApplication = {
          subExamId: el.subExamId,
          sort: el.sort,
          type: el.type
        };
        if (el.type === "自动阅卷") {
          this.$set(tagApplication, "auditStatus", el.auditStatus);
          tagApplication.tagStatusList = getRuleUseConfig(el.type);
          this.$set(tagApplication, "auditDesc", el.auditDesc);
          this.$set(tagApplication, "evalPropName", "auditDesc");
        } else if (el.type === "AI推荐") {
          tagApplication.aiRecommendStatus = el.aiRecommendStatus;
          tagApplication.tagStatusList = getRuleUseConfig(el.type);
        } else if (el.type === "打标签") {
          tagApplication.tagName = el.tagName;
          this.$set(tagApplication, "tagName", el.tagName);
          this.$set(tagApplication, "evalPropName", "tagName");
          this.$set(tagApplication, "tagSentiment", el.tagSentiment);
          this.$set(tagApplication, "tagDesc", el.tagDesc);
        } else if (
          el.type === "自定义Moka成绩回传" ||
          el.type === "自定义moka详情考试结果" ||
          el.type === "自定义MokaAI面试评估结果"
        ) {
          // tagApplication.mokaCustomResult = el.mokaCustomResult;
          this.$set(tagApplication, "mokaCustomResult", el.mokaCustomResult);
          this.$set(tagApplication, "evalPropName", "mokaCustomResult");
        } else if (el.type === "报告评价") {
          this.$set(tagApplication, "messageType", el.messageType);
          this.$set(tagApplication, "evalPropName", "message");
          this.$set(tagApplication, "message", el.message);
          tagApplication.tagStatusList = getRuleUseConfig(el.type);
        }
        // 渲染子节点列表
        console.log(el.matchRuleRoot.subList);
        const ruleList = el.matchRuleRoot?.subList.map((rule: any) => {
          console.log(JSON.parse(JSON.stringify(rule)));
          // detail 规则详情 叶节点
          this.key++;
          this.$set(rule, "key", this.key);
          this.$set(rule, "attribute", rule.detail?.attribute);
          this.$set(rule, "relationship", rule.detail?.relationship);
          const temp = this.attributeList.filter(
            (el: any) => el.name === rule.detail?.attribute
          )[0].dataType;
          const dataTypeList = this.dataTypeList
            .filter((el: any) => el.name === temp)[0]
            .relationshipList.map((el: any) => ({ name: el }));
          this.$set(rule, "dataTypeList", dataTypeList);

          const propName: string[] = [];
          for (const key in rule.detail) {
            if (!ruleConstKey.includes(key) && rule.detail[key]) {
              if (key === "questionId") {
                propName.unshift(key);
              } else {
                propName.push(key);
              }
            }
          }
          this.attributeList.forEach((item: any) => {
            if (item.name === rule.detail?.attribute) {
              this.$set(rule, "dataType", item.dataType);
            }
          });
          if (propName.length > 0) {
            this.$set(rule, "propName", propName);
            propName.forEach(item => {
              this.$set(rule, item, rule.detail[item]);
            });
            this.attributeList.forEach((item: any) => {
              if (item.name === rule.detail.attribute) {
                if (propName.length === 1) {
                  const tagAttrList = this.catchTagAttrList(0, item);
                  this.$set(rule, "tagAttrList", [tagAttrList]);
                  const inputType = this.changeAttr(propName[0], rule);
                  // this.$set(rule, "inputType", inputType);
                } else {
                  const arr: any = [];
                  let inputType = "";
                  propName.forEach((_: any, index: number) => {
                    const tagAttrList = this.catchTagAttrList(index, item);
                    arr.push(tagAttrList);
                    const input = this.changeAttr(_, rule);
                    inputType = input || inputType;
                  });
                  this.$set(rule, "inputType", inputType);
                  this.$set(rule, "tagAttrList", arr);
                }
              }
            });
          } else {
            this.$set(rule, "tagAttrList", [[]]);
          }
          if (
            rule.detail &&
            rule.detail.valueRange &&
            rule.detail.valueRange.length > 1
          ) {
            this.$set(rule, "value1", rule.detail.valueRange[0]);
            this.$set(rule, "value2", rule.detail.valueRange[1]);
          } else if (
            rule.detail &&
            rule.detail.valueRangeFloat &&
            rule.detail.valueRangeFloat.length > 1
          ) {
            this.$set(rule, "value1", rule.detail.valueRangeFloat[0]);
            this.$set(rule, "value2", rule.detail.valueRangeFloat[1]);
          } else {
            console.log(rule.detail);
            this.$set(
              rule,
              "value",
              rule.detail.valueInt == 0 || rule.detail.valueInt == undefined
                ? rule.inputType
                  ? rule.detail.valueStrings.join("，")
                  : rule.detail.valueStrings
                : rule.detail.valueInt
            );
          }
          delete rule.detail;
          return rule;
        });
        ruleSetList.push({
          tagForm,
          ruleList,
          tagApplication,
          key: this.ruleKey,
          applicationRuleId: el.applicationRuleId
        });
      }
    });
    if (ruleSetList.length > 0) {
      this.ruleSetList = ruleSetList;
    } else {
      this.ruleSetList = JSON.parse(JSON.stringify(this.form));
    }
    console.log("***", this.ruleSetList);
    this.$nextTick(() => {
      this.scrollByRuleIndex(this.modifyOrAddIndex);
      this.handleOnlyModifyOneRule();
    });
  }

  async getSubList() {
    const res = await ExamList.getList(({
      onlySubExam: 1
    } as unknown) as ExamListForm);
    this.subList = res.exams;
  }

  addRuleAndScrollBottom() {
    this.addRule();
    this.$nextTick(() => {
      this.scrollBottom();
    });
  }

  addRule() {
    this.ruleKey = this.getRuleKey();
    const temp = JSON.parse(JSON.stringify(defaultSetRule));
    this.displayRuleSetList.push({
      ...temp,
      key: this.ruleKey
    });
  }

  addTag(ruleList: RuleForm[]) {
    this.key++;
    ruleList.push({
      attribute: "",
      relationship: "",
      value: "",
      dataType: "testResult",
      key: this.key,
      propName: [],
      dataTypeList: []
    });
  }

  async getList() {
    // /aiExam/common/tagEngine
    const res = await request.post("/aiExam/common/tagEngine");
    const data = res.data.data;
    this.attributeList = data.attributeList.filter(
      (el: any) => el.name !== "简历信息" && el.name !== "特殊逻辑"
      //  &&
      // !el.name.includes("维度组")
    );
    this.dataTypeList = data.dataTypeList;
    this.anaylisList();
  }

  changeAttr(item: string, tag: any) {
    console.log(item, tag);
    console.log(this.exam);
    if (item === "paramName") {
      const paramItem = this.exam.paramList.filter(
        el => el.name === tag.paramName
      )[0];
      this.$set(tag, "inputType", "");
      if (paramItem?.inputType === "choice") {
        this.$set(
          tag,
          "valueOptions",
          paramItem.singleChoiceOptions.map(el => ({ name: el }))
        );
      } else if (paramItem?.inputType === "multiChoice") {
        this.$set(
          tag,
          "valueOptions",
          paramItem.mutiChoiceOptions.map(el => ({ name: el.key }))
        );
      } else {
        this.$set(tag, "inputType", paramItem?.inputType);
      }
      return paramItem?.inputType;
    } else if (item === "questionId" && tag.attribute === "选择题选项") {
      const questionMap = this.exam.examScoreConfigList.filter(
        el => el.questionId === tag.questionId
      );
      this.$set(
        tag,
        "valueOptions",
        questionMap[0]?.choiceQuestionScoreList?.map(el => ({
          name: el.optionKey
        }))
      );
    }
  }

  changeType(value: string, tag: any) {
    const normalMap = {
      questionId: "questionIdList",
      dimensionName: "dimensionKeyList"
    };
    this.attributeList.forEach((item: any) => {
      if (item.name === value) {
        this.$set(tag, "value", "");
        this.$set(tag, "value1", "");
        this.$set(tag, "value2", "");
        this.$set(tag, "relationship", "");
        this.$set(tag, "dataType", item.dataType);
        const dataTypeList = this.dataTypeList
          .filter((el: any) => el.name === item.dataType)[0]
          .relationshipList.map((el: any) => ({ name: el }));
        this.$set(tag, "dataTypeList", dataTypeList);
        this.$set(tag, "propName", item.extraNeedList);
        item.extraNeedList.forEach((el: any) => {
          this.$set(tag, el, "");
        });
        // extraNeedList为空属性与类型相同
        if (!item.extraNeedList.length) {
          this.$set(tag, "tagAttrList", [[]]);
        } else if (item.extraNeedList.length === 1) {
          // 1个关联项，对应面试中格式为普通数组的 eg.['1','2']
          const tagAttrList = this.catchTagAttrList(0, item);
          this.$set(tag, "tagAttrList", [tagAttrList]);
        } else {
          // 大于1个关联项
          const arr: any = [];
          item.extraNeedList.forEach((_: any, index: number) => {
            const tagAttrList = this.catchTagAttrList(index, item);
            arr.push(tagAttrList);
          });
          this.$set(tag, "tagAttrList", arr);
        }
      }
    });
  }

  catchTagAttrList(index: number, item: any) {
    // 通用处理，对应面试中格式为普通数组的 eg.['1','2']
    const normalMap = {
      questionId: "questionIdList",
      dimensionName: "dimensionKeyList"
    };
    if (normalMap[item.extraNeedList[index]]) {
      const tagAttrList = this.exam[
        normalMap[item.extraNeedList[index]]
      ].map((el: any) => ({ name: el }));
      return tagAttrList;
      // this.$set(this, 'tagAttrList', [tagAttrList])
    } else if (item.extraNeedList[index] === "paramName") {
      // paramName: 'paramList'
      const tagAttrList = this.exam.paramList
        .filter(el => el.isShow === 1)
        .map((el: any) => ({ name: el.name }));
      return tagAttrList;
      // this.$set(this, 'tagAttrList', [tagAttrList])
    } else if (item.extraNeedList[index] === "dimensionGroupName") {
      let tagAttrList = [];
      if (!this.isEditExam) {
        //新建面试时
        tagAttrList = this.dimensionGroupConfigList.map(item => ({
          name: item.groupName
        }));
      } else {
        //编辑面试时
        tagAttrList = this.exam.dimensionGroupConfigList.map(item => ({
          name: item.groupName
        }));
      }
      return tagAttrList;
    }
  }

  getStatusList(value: string, rule: any) {
    rule.tagApplication.auditStatus = "";
    console.log(this.ruleUseList, rule, "rule!!!!");
    this.ruleUseList.forEach(item => {
      if (item.value == value) {
        delete rule.tagApplication[rule.tagApplication.evalPropName];
        rule.tagApplication.tagStatusList = item.statusList;
        this.$set(rule.tagApplication, "evalPropName", item.propName);
        // rule.tagApplication.evalPropName = item.propName
        this.$set(rule.tagApplication, rule.tagApplication.evalPropName, "");
      }
    });
  }

  removeTag(key: number, ruleList: any, rule: any) {
    rule.ruleList = ruleList.filter((el: any) => el.key !== key);
  }

  deleteRule(key: number) {
    this.displayRuleSetList = this.displayRuleSetList.filter(
      (el: any) => el.key !== key
    );
  }

  // 复制当前 index 所在的行，并添加到下一行
  copyRule(index: number) {
    const rule = JSON.parse(JSON.stringify(this.displayRuleSetList[index]));
    const ruleKey = this.getRuleKey();
    this.ruleKey = ruleKey;
    this.displayRuleSetList.splice(index + 1, 0, { ...rule, key: ruleKey });
    this.scrollByRuleIndex(index + 1);
    console.log("💩 ～ copyRule: ", this.displayRuleSetList);
  }

  getRuleKey() {
    // 防止 key 重复，每次找到 displayRuleSetList 中最大的 key 值
    return Math.min(...this.displayRuleSetList.map((el: any) => el.key)) - 1;
  }

  handleClick(row: any) {
    console.log(row);
  }

  ok() {
    //todo 一些校验可以在这里做
    const validator = this.handleBeforeOk();
    if (validator) {
      const data = this.checkData();

      if (data) {
        this.$emit("ok", data, "tag");
        this.$emit("update:visible", false);
      }
    }

    // this.close()
  }

  close() {
    // this.$emit("ok", this.applicationRuleList, "tag");
    this.$emit("update:visible", false);
  }

  //离开前校验
  checkData() {
    let checkResult = true;
    const tagApplicationList: any = [];
    console.log(
      "💩 ~ TagEdit ~ this.ruleSetList.forEach ~ this.ruleSetList:",
      this.ruleSetList
    );
    this.ruleSetList.forEach((rule: Rule, index: number) => {
      // delete rule.key;
      if (rule.tagApplication.evalPropName === "") {
        delete rule.tagApplication[rule.tagApplication.evalPropName];
      } else {
        // rule.tagApplication[rule.tagApplication.evalPropName as string] =
        //   rule.tagApplication[""];
        delete rule.tagApplication[""];
      }
      delete rule.tagApplication.evalPropName;
      delete rule.tagApplication.tagStatusList;
      const tagApplication: any = rule.tagApplication;

      const subList: any = [];
      // delete rule.key;
      rule.ruleList.forEach((tag: RuleForm, indexNew: number) => {
        if (tag.attribute === "") {
          this.$message.error(
            `规则集${index +
              1}的标签属性为空，请选择该规则集的标签属性或者删除该规则集`
          );
          checkResult = false;
          return;
        }
        if (tag.dataType === "range") {
          tag.valueRange = [Number(tag.value1), Number(tag.value2)];
          delete tag.value1;
          delete tag.value2;
        } else if (tag.dataType === "rangeFloat") {
          if (isNaN(Number(tag.value1)) || isNaN(Number(tag.value2))) {
            this.$message.error(`规则集${index + 1}的配置项必须是数字`);
            checkResult = false;
            return;
          }
          tag.valueRangeFloat = [Number(tag.value1), Number(tag.value2)];
          delete tag.value1;
          delete tag.value2;
        } else if (tag.dataType === "int") {
          tag.valueInt = Number(tag.value);
        } else {
          if (Array.isArray(tag.value)) {
            tag.valueStrings = tag.value as string[];
          } else {
            tag.valueStrings = String(tag.value)?.split("，");
          }
        }
        const deleteKeys = [
          "key",
          "value",
          "dataTypeList",
          "inputType",
          "valueOptions",
          "tagAttrList",
          "dataType"
        ];
        deleteKeys.forEach(key => {
          delete tag[key];
        });
        subList.push({
          ruleId: tag.ruleId,
          detail: tag,
          mergeType: "",
          subList: []
        });
      });
      const matchRuleRoot: any = {
        mergeType: rule.tagForm.mergeType,
        subList: subList
      };
      tagApplication.key = rule.key;
      tagApplication.applicationRuleId = rule.applicationRuleId || "";
      tagApplication.matchRuleRoot = matchRuleRoot;
      tagApplication.sort = index + 1;
      tagApplicationList.push(tagApplication);
    });
    if (checkResult) {
      return tagApplicationList;
    } else {
      return false;
    }
  }

  // 滚动到顶部
  scrollTop() {
    const mainBox: any = document.getElementsByClassName("el-dialog__body");
    if (mainBox?.length >= 2) {
      mainBox[1].scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }

  // 滚动到底部
  scrollBottom() {
    const mainBox: any = document.getElementsByClassName("el-dialog__body");
    if (mainBox?.length >= 2) {
      mainBox[1].scrollTo({
        top: mainBox[1].scrollHeight,
        behavior: "smooth"
      });
    }
  }

  // 滚动到指定规则所在位置
  scrollByRuleIndex(index: number) {
    this.$nextTick(() => {
      const mainBox: any = document.getElementsByClassName("el-dialog__body");
      if (mainBox?.length >= 2) {
        const ruleListDom: any = document.querySelectorAll(".rule-list")[index];
        const ruleListDomHeight = ruleListDom?.offsetTop - 130 || 0;
        mainBox[1].scrollTo({
          top: ruleListDomHeight,
          behavior: "smooth"
        });
      }
    });
  }
}
